import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const Bin1 = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.66666 2H13.3333V14C13.3333 14.3536 13.1929 14.6927 12.9428 14.9428C12.6927 15.1929 12.3536 15.3333 12 15.3333H4C3.64638 15.3333 3.30724 15.1929 3.05719 14.9428C2.80714 14.6927 2.66666 14.3536 2.66666 14V2Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M0 2H16"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M6 4.66667V12.6667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.66667V12.6667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M10.146 0H5.854C5.70538 3.90695e-06 5.56102 0.0496681 5.44386 0.141103C5.3267 0.232539 5.24344 0.360502 5.20733 0.504667L4.66666 2.66667H11.3333L10.7927 0.504667C10.7565 0.360502 10.6733 0.232539 10.5561 0.141103C10.439 0.0496681 10.2946 3.90695e-06 10.146 0Z"
      fill="currentColor"
    />
  </svg>,
  'Bin1'
);
